// extracted by mini-css-extract-plugin
export var deleteIcon = "_dt-5";
export var deleteOption = "_dt-3";
export var divider = "_dt-2";
export var downloadIcon = "_dt-4";
export var drawer = "_dt-0";
export var drawerFooter = "_dt-6";
export var drawerOpen = "_dt-1";
export var highlighted = "_dt-7";
export var lighterHighlight = "_dt-8";